var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheckTickCircleBroken = function SvgCheckTickCircleBroken(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#71717A",
    d: "M9 .543a8.458 8.458 0 1 0 7.276 4.143 20.537 20.537 0 0 0-6.183 6.722l-.3.523a.833.833 0 0 1-1.353.132l-2.896-3.35a.833.833 0 1 1 1.261-1.09l2.131 2.465a22.2 22.2 0 0 1 6.352-6.745A8.437 8.437 0 0 0 9 .543ZM15.288 3.343c.371.413.703.863.988 1.343L17 4.192a.833.833 0 0 0-.94-1.376l-.66.45-.111.077Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckTickCircleBroken);
export default ForwardRef;